export const CLICKAWAY_ATTRIBUTE = 'data-clickaway'

export const CLICKAWAY_SCOPES = ['collapse-expanded', 'filter-form', 'card-filters', 'nav-mobile', 'chart'] as const

export type ClickawayScopeType = (typeof CLICKAWAY_SCOPES)[number]
